import * as React from 'react';
import { connect } from "react-redux";
import ActionMenuButton from './ActionMenuButton';
import FunctionMenuButton from './FunctionMenuButton';
import { DefaultButton, Icon, PrimaryButton } from 'office-ui-fabric-react';
import './Home.scss';
import { link } from 'fs';
import { getFrontpageLinks } from '../../actions/Action_Home';
import { FrontPageLink } from '../../models/FrontpageLink';
import { toggleSidebar } from '../../actions/Action_Sidebar';


let actionButtonsTeacher = [
  {
    title: "Lag ny plan",
    icon: "Calendar",
    link: "/#/ukeplan/nytt_innslag/n",
  },
  {
    title: "Lag ny innlevering",
    icon: "CompletedSolid",
    link: "/#/task/ny_innlevering/n",
  },
  {
    title: "Lag ny melding",
    icon: "Chat",
    link: "/#/meldinger/ny_melding",
  },
  {
    title: "Lag ny prøve",
    icon: "PageListSolid",
    link: "/#/quiz/nytt_innslag/n",
  }
]

let functionButtonsTeacher = [
  {
    title: "Ukeplan",
    icon: "Calendar",
    link: "/#/ukeplan",
  },
  {
    title: "Innlevering",
    icon: "CompletedSolid",
    link: "/#/innleveringer",
  },
  {
    title: "Timeplan",
    icon: "DateTime",
    link: "/#/timeplan",
  },
  {
    title: "Prøver",
    icon: "PageListSolid",
    link: "/#/quiz",
  },
  {
    title: "Meldinger",
    icon: "Chat",
    link: "/#/meldinger",
  },
  {
    title: "Portefølje",
    icon: "OpenFolderHorizontal",
    link: "/#/portefolje",
  },
  {
    title: "IUP",
    icon: "Transition",
    link: "/#/iup",
  },
  {
    title: "Administrasjon",
    icon: "Settings",
    link: "/#/admin",
  },
  {
    title: "Søkesenter",
    icon: "Search",
    link: "/#/discovery",
  }
]

let functionButtonsStudent = [
  {
    title: "Ukeplan",
    icon: "Calendar",
    link: "/#/ukeplanstudent",
  },
  {
    title: "Innlevering",
    icon: "CompletedSolid",
    link: "/#/innleveringerstudent",
  },
  {
    title: "Timeplan",
    icon: "DateTime",
    link: "/#/timeplanstudent",
  },
  {
    title: "Prøver",
    icon: "PageListSolid",
    link: "/#/quizstudent",
  },
  {
    title: "Portefølje",
    icon: "OpenFolderHorizontal",
    link: "/#/portefoljestudent",
  }
]

let shortcutButtons = [
  {
    title: "Kommunens startside",
    icon: "Calendar",
    link: "https://vg.no"
  },
  {
    title: "Creaza",
    icon: "Calendar",
    link: "https://vg.no"
  },
  {
    title: "Mine innleveringer",
    icon: "Task",
    link: "/innleveringer"
  },
  {
    title: "Mine meldinger",
    icon: "Mail",
    link: "/meldinger"
  },
  {
    title: "Mine prøver",
    icon: "Quiz",
    link: "/prøver"
  }
]


export interface IHomeProps {
  history: any;
  user: any;
  frontPageLinks: FrontPageLink[];
  getFrontpageLinks: () => any;
  toggleSidebar: (open: boolean) => void;
}

export interface IHomeState {
  frontPageLinks: FrontPageLink[];
}

class Home extends React.Component<IHomeProps, IHomeState> {
  constructor(props: IHomeProps) {
    super(props);
    this.props.toggleSidebar(false);
    this.state = {
      frontPageLinks: [],
    };
  }

  async componentDidMount() {
    if (this.props.frontPageLinks.length === 0) {
      let result = await this.props.getFrontpageLinks();

      if (result.data && result.data.length > 0) {
        this.setState({
          frontPageLinks: result.data,
        });
      }
    }
    
  }
  
  render() {
    let actionButtons = [];
    let functionButtons = [];

    if (this.props.user && this.props.user.role === 'teacher') {
      actionButtons = actionButtonsTeacher;
      functionButtons = functionButtonsTeacher;
    }

    if (this.props.user && this.props.user.role === 'student') {
      functionButtons = functionButtonsStudent;
    }

    let frontPageLinks = this.props.frontPageLinks ? this.props.frontPageLinks : this.state.frontPageLinks;

    return (
        <div className='ms-Grid home-container'>
            <div className='ms-Grid-row' style={{textAlign: 'center', overflow: 'hidden'}}>
              <img src={require('../../../public/Zokrates.png')} alt="Logo" className='logo-image'/>
            </div>
            <div className="home-buttons-container" >
              <div className="main-button-wrapper">
                {actionButtons.length > 0 &&
                  <div className='ms-Grid-row' style={{marginBottom: "20px"}}>
                    <h2>Rett på sak</h2>
                    {/* Wrap if no space */}
                      <div style={{display:'flex', flexDirection:'row', flexWrap:'wrap'}}>
                        {actionButtonsTeacher.map((button, index) => (
                          <div className='menu-button-wrapper'>
                            <ActionMenuButton
                              title={button.title}
                              icon={button.icon}
                              link={button.link}
                              onClick={() => this.props.toggleSidebar(true)}
                            />
                          </div>
                        ))}
                      </div>
                  </div>
                }

                {functionButtons.length > 0 &&
                  <div className='ms-Grid-row' style={{marginBottom: "20px"}}>
                    <h2>Gå til</h2>
                    <div style={{display:'flex', flexDirection:'row', flexWrap:'wrap'}}>
                      {functionButtons.map((button, index) => (
                        <div className="menu-button-wrapper">
                          <FunctionMenuButton
                            title={button.title}
                            icon={button.icon}
                            link={button.link}
                            onClick={() => this.props.toggleSidebar(true)}
                          />
                        </div>
                      ))}
                    </div>

                  </div>
                }
              </div>
              <div className='ms-Grid-row shortcut-buttons-container'>
                <h2>Mine snarveier</h2>
                {frontPageLinks && <div style={{display:'flex', flexDirection:'row', flexWrap:'wrap', justifyContent: 'start'}}>
                  {frontPageLinks.map((button, index) => (
                    <div className='shortcut-button'>
                      <a href={button.Link} target="_blank">
                        <DefaultButton styles={{
                            root:{width:'100%', height: '5em', borderRadius: '12px', backgroundColor: '#AA1010', color: 'white', padding: '0px 4px'}, 
                            rootHovered: {backgroundColor: '#bb1111', color: 'white'},
                            rootPressed: {backgroundColor: '#AA1010', color: 'white'},
                          }}
                          aria-label={button.Title}
                        >
                          {button.Icon && <div className='ms-Grid-col ms-md3' style={{textAlign: 'center', width: '30%'}}>
                            <i className={button.Icon} style={{fontSize: '23px', padding: '0px 0px 0px 6px'}}/>
                          </div>}
                          <div className='ms-Grid-col ms-md9' style={{width: '100%'}}>
                            <span className="ms-Button-label" style={{fontSize: '14px', wordBreak: 'initial'}}>{button.Title}</span>
                          </div>
                        </DefaultButton>
                      </a>
                      
                    </div>
                  ))}
                </div>}
              </div>
            </div>
        </div>
    )
  }
}

function mapStateToProps(state) {
  let frontPageLinks = [];
  if (state.home && state.home.frontPageLinks) {
    state.home.frontPageLinks.sort((a, b) => b.SortOrder - a.SortOrder);
    frontPageLinks = state.home.frontPageLinks;
  }

  return {
    user: state.teacher.user,
    frontPageLinks: frontPageLinks,
  };
}

export default connect(mapStateToProps, {
  getFrontpageLinks,
  toggleSidebar,
})(Home);
